import React, {useState} from 'react';
import RightProductArrow from "../../images/RightProductArrow";

interface HeaderProductsItemProps {
	title: string;
	description: string;
	onPress: () => void;
	type: "Combine" | "Platform" | "Trading" | "Something";
	mode: 'dark' | 'light';
}

const HeaderProductsItem = (props: HeaderProductsItemProps) => {
	const [isProductHovered, setIsProductHovered] = useState(false);

	return (
		<button
			className="headerProductsItem"
			onMouseEnter={() => setIsProductHovered(true)}
			onMouseLeave={() => setIsProductHovered(false)}
			onClick={props.onPress}
		>
			<div className="platformImage">
{/*				{
					props.type !== "Platform" ? (*/}
						<img
							className={`iconItem ${props.type}`}
							src={`${process.env.PUBLIC_URL}/assets/images/Nfd${props.type}${props.type === 'Something' ? props.mode === 'dark' ? 'Light' : 'Dark' : ''}.svg`}
							alt={`Image ${props.type}`}
						/>
{/*					) : null
				}*/}
			</div>
			<div className="infoWrap">
				<div className={`info ${props.mode}`}>
					<h3>{props.title}</h3>
					<span>{props.description}</span>
				</div>
				<RightProductArrow
					color={
						props.mode === 'dark' ?
							isProductHovered ?
								"#D6B0FF"
								:
								"#fff"
							:
							isProductHovered ?
								"#7551FF"
								:
								"#080015"
					}
				/>
			</div>
		</button>
	);
};

export default HeaderProductsItem;